// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	
});

/**
 *	Adds an event handler that runs when the dataset is ready.
 */

export function dynamicDataset_ready() {
	let findPrimaryPerformer = (e) => e.performers.filter(p => p.primary == true);
	let findHomeTeam = (e) => e.performers.filter(p => p.home_team == true);

	let data = $w('#dynamicDataset').getCurrentItem();

	let performer = null;
	if (data.type == 'concert') {
		performer = findPrimaryPerformer(data);
	} else if (data.type == 'nfl') {
		performer = findHomeTeam(data);
	}

	if (performer.length && performer[0].image) {
		$w('#image').src = performer[0].image
	}
}